export function tiltintStories(count: number, singular: string, plural: string, dual: string) {
	if (count === 1) {
		return `1 ${singular}`;
	} else if (count >= 2 && count <= 4) {
		return `${count} ${plural}`;
	} else {
		return `${count} ${dual}`;
	}
}
